import { EmptyState, FlexBox, Spinner } from '@dixa/lib-shared-habla';

export const AnalyticsLoading = (): JSX.Element => {
  return (
    <FlexBox
      flexDirection="column"
      height="100%"
      alignItems="center"
      justifyContent="center"
      gap="400"
    >
      <Spinner />

      <EmptyState
        title="Initializing..."
        description="Please wait a moment"
        icon={null}
      />
    </FlexBox>
  );
};
